module.exports = __webpack_public_path__ + "media/taxi/images/location-d70cb18281d1f295c9f33b01527d7862.svg";